import React, { useEffect, useState } from 'react';
import { BlobService, createBlobServiceWithSas } from '../../plugins/azure/js/azure-storage.blob';
import { Tree } from 'antd';
import type { DataNode, DirectoryTreeProps } from 'antd/es/tree';
import { Button, Col, DownloadIcon, FileIcon, FolderIcon, Modal, PlusIcon, Row, Table, Text, Title } from 'melco-ui';
import { useTableSelection } from '../../hooks/table/useTableSelection';
import { AddFolderDrawer } from './drawer/AddFolderDrawer';
import { FileUploadButton } from './FileUploadButton';
import { DeleteDownloadSingleFile } from './DeleteDownloadSingleFile';
import { ButtonWrapper, getNodePath } from '../../helper/downloadHelper';
import Progress from 'antd/es/progress';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { CopyableTextEllipsis } from '../text/CopyableTextEllipsis';


type DownloadContainerPropTypes = {
  // openAddFolderDrawer?: boolean;
  // setOpenAddFolderDrawerFunction?: (v: boolean) => void
  appSettingsResponse: any;
}

const Wrapper = styled.div`
margin-top:15px;
`
export const DownloadsContainer: React.FC<DownloadContainerPropTypes> = ({ appSettingsResponse }) => {
  const { t } = useTranslation();
  const { DirectoryTree } = Tree;
  const [isLoading, setIsLoading] = useState(true);
  const [STORAGE_URI, setStorageUri] = useState(appSettingsResponse.download_storage_uri);
  const [SAS, setSas] = useState(appSettingsResponse.download_storage_sas);

  const [CONTAINER, setContainer] = useState(appSettingsResponse.download_storage_container);
  const [DOWNLOAD_HOST, setDownloadHost] = useState(appSettingsResponse.download_host);
  const [treeDataState, setTreeDataState] = useState<DataNode[]>([]);
  const [leftHandSideTreeData, setLeftHandSideTreeData] = useState<DataNode[]>([])

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [selectedPath, setSelectedPath] = useState("");
  const [selectedNode, setSelectedNode] = useState<DataNode>({ "title": "", isLeaf: false, key: 0, children: [] });
  const columns = [

    {
      'title': t('downloadfiles.table.columns.name'),
      width: 150,
      render: (rowObj: any) => {
        return (
          <>
            {
              rowObj.isLeaf ?
                <span>
                  <FileIcon />
                </span>
                :
                <span><FolderIcon /></span>
            }
            &nbsp; <span>
              {rowObj.title}
            </span>
          </>
        )
      },
      "key": "title",
    },
    {
      title: t('downloadfiles.table.columns.path'),
      width: 150,
      render: (rowObj: any) => {
        let str = getNodePath(rowObj, treeDataState);
        let link = DOWNLOAD_HOST + str;
        return (
          <>
            {
              rowObj.isLeaf && <CopyableTextEllipsis
                text={link}
                // copiedToolTip='kkk'
                copyTooltip={t('downloadfiles.actions.copy.copytooltip')}
                onCopiedMessage={t('downloadfiles.actions.copy.copiedmessage')}
                ellipsis={true}
              />
            }
          </>)
      }
    },
    {
      "title": t('downloadfiles.table.columns.action'),
      width: 110,
      render: (rowObj: any) => {
        let str = getNodePath(rowObj, treeDataState);
        return (
          <>
            {
              rowObj.isLeaf && <>
                <Row>
                  <ButtonWrapper>
                    <a rel="noopener noreferrer" href={DOWNLOAD_HOST + str} target="_blank">
                      <Button
                        //icon={<DownloadIcon />}
                        type="primary"
                        onClick={() => { }}>
                        <DownloadIcon />
                      </Button>
                    </a>
                  </ButtonWrapper>
                  <a>
                    {/* <DeleteIcon /> */}
                    <ButtonWrapper>
                      <DeleteDownloadSingleFile
                        row={rowObj}
                        treeData={treeDataState}
                        refetch={refetch}
                        appSettingsResponse={appSettingsResponse}

                      />
                    </ButtonWrapper>
                  </a>
                </Row>
              </>
            }

          </>
        )
      }
    }
  ]

  const [uploadProgressPercent, setUploadProgressPercent] = useState(0);
  const [uploadProgressBarModalOpen, setUploadProgressBarModalOpen] = useState<boolean>(false);


  useEffect(() => {
    getFiles(f.prefix, "")
    return () => {

    }
  }, [])




  let f = {
    BlobService: BlobService,
    prefix: ""
  };
  const [childrenDataCurrentNode, setChildrenDataCurrentNode] = useState<any>([]);
  f.BlobService = createBlobServiceWithSas(STORAGE_URI, SAS);
  f.prefix = '';

  const [openAddFolderDrawer, setOpenAddFolderDrawer] = useState<boolean>(false);

  const setOpenAddFolderDrawerFunction = (v: boolean) => {
    setOpenAddFolderDrawer(v);
  }

  let getNameByFolderLevel = function (path: any, level: any) {
    let parts = path.split('/');
    parts = parts.filter(function (el: any) { return el !== null; });
    if (parts.length - 1 === level || parts.length > level + 1) {
      return parts[level];
    } else {
      return '';
    }
  };

  const isFile = function (name: any) {
    if (name.indexOf('.') !== -1 && name.split('/').length == 1)
      return true;
    else
      return false;
  };

  const getFiles = (prefix: any, keyPrefix: any) => {
    setIsLoading(true)
    keyPrefix = keyPrefix == '' ? "0" : keyPrefix;
    // console.log("Prefix key getfile ", prefix, "    ", keyPrefix)
    f.BlobService.listBlobsSegmentedWithPrefix(CONTAINER, prefix, null, function (error: any, results: any) {
      let level = prefix.split('/').length - 1;
      if (error) {
        console.log(error);
        alert('error getting files list. refresh browser to try again.');
        setIsLoading(false)
      } else {
        let items = new Array();
        if (results.entries.length > 0) {
          let tempTreeData: DataNode[] = [];
          let tempLeftHandSideTreeData: DataNode[] = [];
          let childrenOfCurrentNode = []
          for (let i = 0, j = 0, blob; blob = results.entries[i]; i++) {
            let name = getNameByFolderLevel(blob.name, level);
            let is_file = isFile(blob.name.replace(prefix, ''));
            if (!items.includes(name)) {
              items.push(name);

              tempTreeData.push({
                "title": name,
                "isLeaf": is_file,
                "key": keyPrefix + "-" + j,
                "children": []
              })

              childrenOfCurrentNode.push({
                "title": name,
                "key": keyPrefix + "-" + j,
                "isLeaf": is_file
              })
              if (!is_file) {
                tempLeftHandSideTreeData.push({
                  "title": name,
                  "isLeaf": is_file,
                  "key": keyPrefix + "-" + j,
                  children: []
                })
              }

              j++;

            }
          }
          setChildrenDataCurrentNode(childrenDataCurrentNode)
          if (prefix == "") {
            setTreeDataState(tempTreeData);
            setLeftHandSideTreeData(tempLeftHandSideTreeData)
          }
          else {

            setLeftHandSideTreeData(updateTreeData(leftHandSideTreeData, keyPrefix, tempLeftHandSideTreeData));
            setTreeDataState(updateTreeData(treeDataState, keyPrefix, tempTreeData))
          }
          setChildrenDataCurrentNode(childrenOfCurrentNode);
        } else {
          setChildrenDataCurrentNode([])
        }
        setIsLoading(false)
      }
    });
  }

  const getFoldersForLefthandSide = (prefix: any, keyPrefix: any) => {
    keyPrefix = keyPrefix == '' ? "0" : keyPrefix;
    // console.log("Prefix key getfile ", prefix, "    ", keyPrefix)
    f.BlobService.listBlobsSegmentedWithPrefix(CONTAINER, prefix, null, function (error: any, results: any) {
      let level = prefix.split('/').length - 1;
      if (error) {
        alert('error getting files list. refresh browser to try again.');
      } else {
        let items = new Array();
        if (results.entries.length > 0) {
          let tempTreeData: DataNode[] = [];
          let tempLeftHandSideTreeData: DataNode[] = [];
          for (let i = 0, j = 0, blob; blob = results.entries[i]; i++) {
            let name = getNameByFolderLevel(blob.name, level);
            let is_file = isFile(blob.name.replace(prefix, ''));
            if (!items.includes(name)) {
              items.push(name);

              tempTreeData.push({
                "title": name,
                "isLeaf": is_file,
                "key": keyPrefix + "-" + j,
                "children": []
              })


              if (!is_file) {
                tempLeftHandSideTreeData.push({
                  "title": name,
                  "isLeaf": is_file,
                  "key": keyPrefix + "-" + j,
                  children: []
                })
              }

              j++;

            }
          }
          if (prefix == "") {
            setTreeDataState(tempTreeData);
            setLeftHandSideTreeData(tempLeftHandSideTreeData)
          }
          else {
            setLeftHandSideTreeData(updateTreeData(leftHandSideTreeData, keyPrefix, tempLeftHandSideTreeData));
            setTreeDataState(updateTreeData(treeDataState, keyPrefix, tempTreeData))
          }
        } else {

        }
      }
    });
  }



  const refetch = () => {
    //  getFiles(selectedpathsToDelete[0].substring(0, selectedpathsToDelete[0].lastIndexOf("/")), parentNodeOfDelete?.key)
    console.log("selected path ", selectedPath)
    console.log("selected Node.key ", selectedNode.key)
    setTimeout(() => {
      getFiles(selectedPath, selectedNode.key)

    }, 1000)

  }

  const updateTreeData = (list: DataNode[], key: React.Key, children: DataNode[]): DataNode[] =>
    list.map((node) => {
      // console.log(node)
      if (node.key === key) {
        return {
          ...node,
          children,
        };
      }
      if (node.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children),
        };
      }
      return node;
    });

  const setDrawerAction = (action: boolean) => {
    setDrawerOpen(action)
    setOpenAddFolderDrawerFunction(action);
    // openGenerateLicenseDrawer = false;
    // refetch();
  }

  const getNode = (list: DataNode[], key: any): any => {
    return list.map((node) => {
      // console.log(node.key, " === ", key);
      if (node.key === key) {
        return node
      }
      if (node.children) {
        getNode(node.children, key)
      }
      return node;

    })
  }

  // const getNodePath = (node: any): any => {
  //   let f: any = {
  //     key: node.key
  //   };
  //   let str = "";
  //   while (f != undefined) {
  //     let tempKey = f.key;
  //     f = (getParentNode(tempKey, treeDataState));
  //     str = f ? f.title + "/" + str : str
  //   }
  //   str = str + node.title;
  //   return str;
  // }

  // const getParentNode = (key: any, tree: any): any => {
  //   let parentTitle: any;
  //   for (let i = 0; i < tree.length; i++) {
  //     const node = tree[i];
  //     if (node.children) {
  //       if (node.children.some((item: any) => {
  //         return item.key === key
  //       })) {
  //         parentTitle = node;
  //       } else if (getParentNode(key, node.children)) {
  //         parentTitle = getParentNode(key, node.children);
  //       }
  //     }
  //   }
  //   return parentTitle;
  // }

  const { selectedRows, selectedRowKeys, setSelectedRowKeys, rowSelection, } =
    useTableSelection<any>(
      () => {
      },

    );


  // useEffect(() => {

  //   let pathArr: any[] = [];
  //   selectedRows?.map((row: any) => pathArr.push(getNodePath(row)))
  //   setSelectedPathsToDelete(pathArr);

  //   let parentNode = (getParentNode(selectedRowKeys[0], treeDataState));
  //   setParentNodeOfDelete(getParentNode(parentNode?.key, treeDataState))
  //   debugger;
  // }, [selectedRowKeys])



  const onSelect: DirectoryTreeProps['onSelect'] = (keys, info) => {
    if (info.node.style) {
      if (info.node.style.backgroundColor)
        info.node.style.backgroundColor = 'black'

    }
    let str = "";

    str = getNodePath(info.node, treeDataState)
    str = str + "/";
    setSelectedPath(str);
    setSelectedNode(info.node)
    getFiles(str, info.node.key);
  };

  const onExpand: DirectoryTreeProps['onExpand'] = (keys, info) => {

    let str = "";
    str = getNodePath(info.node, treeDataState);
    str = str = str + "/";
    getFoldersForLefthandSide(str, info.node.key);
  };

  const updateLeftHandSideTreeData = (name: string) => {
    let onlyFoldersInLeftHandSide: DataNode[] = []



    childrenDataCurrentNode.map((n: DataNode) => {
      if (!n.isLeaf) {
        onlyFoldersInLeftHandSide.push(n)
      }
    })
    let selectedNodeChildrenLength = onlyFoldersInLeftHandSide.length ?? 0;

    let keyNew = selectedNodeChildrenLength === 0 ? "0" : selectedNodeChildrenLength;
    let tempLeftHandSideTreeDataNode: DataNode = {
      "title": name,
      "isLeaf": false,
      "key": selectedNode.key + "-" + keyNew,
      "children": []
    }

    let tempChildrenOfSelectedNode: DataNode[] = onlyFoldersInLeftHandSide;
    tempChildrenOfSelectedNode.push(tempLeftHandSideTreeDataNode)
    if (selectedPath == "") {
      setTreeDataState(tempChildrenOfSelectedNode);
      setLeftHandSideTreeData(tempChildrenOfSelectedNode)
    }
    else {

      setLeftHandSideTreeData(updateTreeData(leftHandSideTreeData, selectedNode.key, tempChildrenOfSelectedNode));
      setTreeDataState(updateTreeData(treeDataState, selectedNode.key, tempChildrenOfSelectedNode))
    }

  }

  const startUpload = function (file: any) {
    // open MOdal
    try {
      setUploadProgressBarModalOpen(true);
      let customBlockSize = 1024 * 512;
      let fileName = selectedPath + file.name.toLowerCase();

      let speedSummary = f.BlobService.createBlockBlobFromBrowserFile(CONTAINER, fileName, file, { blockSize: customBlockSize }, function (error: any) {
        if (error) {
          setUploadProgressBarModalOpen(false);
          alert('file upload failed:' + error);
        } else {
          getFiles(selectedPath, selectedNode.key);
        }
      });
      speedSummary.on('progress', function () {
        let percent = speedSummary.getCompletePercent();
        // set percentage progress bar
        setUploadProgressPercent(percent)
        console.log(percent);
        if (percent == 100) {
          setTimeout(() => {
            setUploadProgressBarModalOpen(false);
          }, 1000)
        }
      });
    }
    catch (e) {

    }
  };
  return (
    <>
      {/* // breadCrum */}
      <Row>
        <h3>{t('downloadfiles.location')}: <b> {"Container/" + selectedPath}</b></h3>
      </Row>


      {/* <TableActionBarRow> */}
      <Row><ButtonWrapper>
        <FileUploadButton
          uploadFile={startUpload}
        />
      </ButtonWrapper>
        <ButtonWrapper>
          <Button onClick={() => { setDrawerAction(true) }}><PlusIcon /></Button>
        </ButtonWrapper>
      </Row>

      {/* {<BulkActionContainerCol>
        <BulkActionCount selectedCount={selectedRowKeys.length} />
        <BulkActionDeleteDownloadFiles
          selectedPathsToDelete={selectedpathsToDelete}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          refetch={refetch}
          parentNodeOfDelete={parentNodeOfDelete}
        />
      </BulkActionContainerCol>
      } */}
      {/* </TableActionBarRow> */}
      <Wrapper>

        <Row >
          <Col xs={24} md={6} xl={6}>
            <DirectoryTree

              onSelect={onSelect}
              onExpand={onExpand}
              treeData={leftHandSideTreeData}
              style={{ background: 'white', borderRight: '1px solid grey' }}
            />
          </Col>
          <Col xs={24} md={18} xl={18}>
            <Table
              sticky
              dataSource={childrenDataCurrentNode}
              columns={columns}
              rowClassName={(record:any) => !record.isLeaf ? "disabled-row" : "" }
              loading={isLoading}
              rowKey="key"
            // rowSelection={rowSelection}
            />

          </Col>
        </Row>
      </Wrapper>
      {<AddFolderDrawer
        isDrawerOpen={openAddFolderDrawer}
        setDrawerOpen={setDrawerAction}
        callBackFn={updateLeftHandSideTreeData}
      />}
      {
        uploadProgressBarModalOpen && <Modal
          open={uploadProgressBarModalOpen}
          closeIcon={null}
          mask={true}
          maskClosable={false}
          footer={null}
          closable={false}
        >

          <Title level={5} > {t('downloadfiles.actions.upload.warning')}</Title>
          <Wrapper>
            <Progress percent={uploadProgressPercent} />
          </Wrapper>

        </Modal>
      }
    </>
  )
}

export default DownloadsContainer;